import React, { FC, HTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

interface GlassmorphicCardProps extends HTMLAttributes<HTMLDivElement> {
    variant?: 'default' | 'elevated' | 'flat'
    children: React.ReactNode
}

export const GlassmorphicCard: FC<GlassmorphicCardProps> = ({
    variant = 'default',
    className,
    children,
    ...props
}) => {
    const variantStyles = {
        default: 'glass-card',
        elevated: 'glass-card shadow-2xl shadow-primary-blue/10',
        flat: 'glass-dark shadow-none',
    }

    return (
        <div
            className={cn(
                'rounded-xl transition-all duration-300',
                variantStyles[variant],
                className
            )}
            {...props}
        >
            {children}
        </div>
    )
}
